import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { confirm } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from "devextreme-angular";
import { NotificationService } from "../common/component/notification/notification.service";
import { ActivityProcessFeedstockService } from "./activity-process-feedstock.service";
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
    selector: 'activity-process-feedstock',
    templateUrl: './activity-process-feedstock.component.html',
    styleUrls: ['./activity-process-feedstock.component.scss']
})

export class ActivityProcessFeedstockComponent {
    @Input() closeButtonVisible: boolean = false;
    @Output() closeEvent = new EventEmitter<boolean>();
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    activityProcessFeedstocks: any[];
    productionactivities: any[];
    specificprocesses: any[];
    feedstocks: any[];
    businesscategories: any;
    isLoadPanelVisible: boolean = false;
    selectedProductionActivityId: string = '';
    selectedSpecificProcessId: string = '';
    selectedFeedstockId: string = '';
    currentEditingRowIndex: number = 0;
    isNewRow: boolean = false;

    readonly allowedPageSizes = [50, 100, 200];

    constructor(private notificationService: NotificationService, private activityProcessFeedstockService: ActivityProcessFeedstockService) {
        this.getActivityProcessFeedstocks();
        this.getProductionActivities();
        this.getSpecificProcesses();
        this.getFeedstocks();
        this.getBusinessCategories();
        this.getProdActivities = this.getProdActivities.bind(this);
        this.getSpecificProcessesDataSource = this.getSpecificProcessesDataSource.bind(this);
        this.getFeedstockDataSource = this.getFeedstockDataSource.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    getActivityProcessFeedstocks() {
        this.isLoadPanelVisible = true;
        this.activityProcessFeedstockService.getActivityProcessFeedstocks().subscribe({
            next: activityProcessFeedstocks => {
                this.activityProcessFeedstocks = activityProcessFeedstocks;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.notificationService.alert("error", "Error while fetching Activity Process Feedstocks", error);
            }
        });
    }

    onSaveClick(e) {
        this.dataGrid.instance.saveEditData();
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.dataGrid.instance.cancelEditData();
            }
        });

    }

    addNew() {
        this.dataGrid.instance.addRow();
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
    }

    onClose() {
        this.closeEvent.emit(true);
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Activity Process Feedstock.xlsx');
                });
        });
        e.cancel = true;
    }

    onEditorPreparing(e) {
        if (e.parentType === 'dataRow' && e.dataField === 'productionActivityId' && !e.value) {
            this.selectedProductionActivityId = '';
        }

        if (e.parentType === 'dataRow' && e.dataField === 'specificProcessId' && !e.value) {
            this.selectedSpecificProcessId = '';
        }

        if (e.parentType === 'dataRow' && e.dataField === 'feedstockId' && !e.value) {
            this.selectedFeedstockId = '';
        }


    }

    getProductionActivities() {
        this.isLoadPanelVisible = true;
        this.activityProcessFeedstockService.getProductionActivities().subscribe({
            next: productionactivities => {
                this.productionactivities = productionactivities;
                this.refreshPopup();
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Production Activities", error);
            }
        });
    }

    getSpecificProcesses() {
        this.isLoadPanelVisible = true;
        this.activityProcessFeedstockService.getSpecificProcesses().subscribe({
            next: specificprocesses => {
                this.isLoadPanelVisible = false;
                this.specificprocesses = specificprocesses;
                this.refreshPopup();
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Specific Processes", error);
            }
        });
    }

    getFeedstocks() {
        this.isLoadPanelVisible = true;
        this.activityProcessFeedstockService.getFeedstocks().subscribe({
            next: feedstocks => {
                this.isLoadPanelVisible = false;
                this.feedstocks = feedstocks;
                this.refreshPopup();
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Feedstocks", error);
            }
        });
    }

    refreshPopup() {
        if (this.dataGrid && !this.isNewRow) {
            this.dataGrid.instance.cancelEditData();
            this.dataGrid.instance.editRow(this.currentEditingRowIndex);
        } else if (this.isNewRow) {
            this.dataGrid.instance.cancelEditData();
            this.dataGrid.instance.addRow();
        }
    }

    getBusinessCategories() {
        this.activityProcessFeedstockService.getBusinessCategories().subscribe({
            next: businesscategories => {
                this.businesscategories = businesscategories;
            }, error: (error: any) => {
                this.notificationService.alert("error", "Error while fetching Business Categories", error);
            }
        });
    }

    onInitNewRow(event) {
        this.isNewRow = true;
        event.data.isActive = true;
        event.data.isOxygenSupply = false;
        event.data.isNitrogenSupply = false;
        event.data.isHydrogenSupply = false;
        event.data.isSyngasSupply = false;
        event.data.isCarbonMonoxideSupply = false;
        event.data.isSteamSupply = false;
        event.data.isCarbonMonoxideSupply = false;

    }

    addActivityProcessFeedstock(event) {
        this.isLoadPanelVisible = true;
        event.data.activityProcessFeedstockId = 0;
        this.activityProcessFeedstockService.addActivityProcessFeedstocks(event.data).subscribe({
            next: data => {
                this.activityProcessFeedstocks = data;
                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Saved successfully', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while Adding Activity Process Feedstock", error);
            }
        });
    }

    onEditingStart(e) {
        this.isNewRow = false;
        this.currentEditingRowIndex = this.dataGrid.instance.getRowIndexByKey(e.key);
    }

    refreshProductionActivities() {
        this.getProductionActivities();
    }

    refreshSpecificProcess() {
        this.getSpecificProcesses();
    }

    refreshFeedstock() {
        this.getFeedstocks();
    }

    getProdActivities(options) {

        if (options.data && options.data.productionActivityId) {
            this.selectedProductionActivityId = options.data.productionActivityId;
        }
        return {
            store: this.productionactivities,
        };

    }

    getSpecificProcessesDataSource(options) {
        if (options.data && options.data.specificProcessId) {
            this.selectedSpecificProcessId = options.data.specificProcessId;
        }
        return {
            store: this.specificprocesses,
        };
    }

    getFeedstockDataSource(options) {
        if (options.data && options.data.feedstockId) {
            this.selectedFeedstockId = options.data.feedstockId;
        }
        return {
            store: this.feedstocks,
        };
    }

    setProductionActivityValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setSpecificProcessValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setFeedstockValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    updateActivityProcessFeedstock(event) {
        this.isLoadPanelVisible = true;
        this.activityProcessFeedstockService.updateActivityProcessFeedstocks(event.data).subscribe({
            next: data => {
                this.activityProcessFeedstocks = data;
                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Updated successfully', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while Updating Activity Process Feedstock", error);
            }
        });
    }

}